import { X } from 'lucide-react';
import type { Tag } from '../../types/tag';

interface TagChipsProps {
  tags: Tag[];
  max?: number;
  onRemove?: (tag: Tag) => void;
}

const PILL = 'inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium';
const NEUTRAL = 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';

export const TagChips = ({ tags, max, onRemove }: TagChipsProps) => {
  const shown = max ? tags.slice(0, max) : tags;
  const overflow = max ? tags.length - shown.length : 0;
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {shown.map((t) => (
        <span
          key={t.id}
          title={t.description || t.name}
          className={`${PILL} ${NEUTRAL}`}
          style={t.color ? { backgroundColor: `${t.color}22`, color: t.color } : undefined}
        >
          {t.code}
          {onRemove && (
            <button type="button" aria-label={`Remove ${t.code}`} onClick={() => onRemove(t)} className="opacity-60 hover:opacity-100">
              <X className="h-3 w-3" />
            </button>
          )}
        </span>
      ))}
      {overflow > 0 && <span className={`${PILL} ${NEUTRAL}`}>+{overflow}</span>}
    </div>
  );
};
